import FormTitle from '@core/components/FormTitle';
import { compraApi } from 'app/services/api/compraApi';
import React from 'react';

const VisualizarCompraAnexos = ({ values = [] }) => {
  const download = async (anexo) => {
    const res = await compraApi().download(compraApi().getAnexoUrl(anexo.id));

    const a = document.createElement('a');
    a.setAttribute('href', `data:${res.data.contentType};base64,${res.data.content}`);
    a.setAttribute('download', res.data.name);
    a.click();
  };

  return (
    <>
      <FormTitle title="Anexo de documentos" />
      {values.map((anexo) => (
        <p className="mb-4">
          <button type="submit" style={{ color: '#53c4e6', fontSize: 15 }} onClick={() => download(anexo)}>
            {anexo?.nome}
          </button>
        </p>
      ))}
    </>
  );
};

export default VisualizarCompraAnexos;
